'use client'

import { useJobStore } from '@stores/job.store'
import { useSearchStore } from '@stores/search.store'

import { useCallback, useMemo } from 'react'

import { JobItem } from '@types'

import { useShallow } from 'zustand/react/shallow'

import { useChatContext } from '@contexts/chat.context'
import { jobApplyButtonClickedEvent } from '@lib/analytics-events'
import { sendGTMEvent } from '@lib/helpers/client'

export default function useApplyForAJob(): () => void {
  const { apply } = useChatContext()
  const [job, setIsApplied] = useJobStore(useShallow((state) => [state.job, state.setIsApplied]))
  const [search, serpPositionClicked] = useSearchStore(useShallow((state) => [state.search, state.serpPositionClicked]))
  const eventData = useMemo<Record<string, string | boolean>>(
    () => ({
      event_label: job?.id || '',
      jobId: job?.id || '',
      jobTitle: job?.title || '',
      jobFeed: job?.feed || '',
      jobGroupCategory: job?.groupCategory || '',
      jobSource: job?.source || '',
      jobCompanyName: job?.companyName || '',
      searchMicroRole: search.job.micro,
      searchMacroRole: search.job.macro || '',
      searchLocationName: search.location.name,
      searchLocationType: search.location.type,
      searchLocationId: search.location.id,
      non_interaction: true,
      position: String(serpPositionClicked),
      search_score: String(job?.classification?.score),
      search_strategy: search.sort,
      chat_mass_apply: false,
    }),
    [job, search, serpPositionClicked],
  )

  return useCallback(() => {
    jobApplyButtonClickedEvent(job as unknown as JobItem, search)
    sendGTMEvent('beginApplication')
    if (job) apply([job.id], setIsApplied, eventData)
  }, [apply, setIsApplied, eventData, job, search])
}
